<!-- Start Breadcrumbs -->
<!-- <app-breadcrumbs title="DASHBOARD" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs> -->
<!-- End Breadcrumbs -->

<div class="row">
    <div class="col">

        <div class="h-100 db-max-width">
            <div class="row mb-3 pb-1">
                <div class="col-12">
                    <div class="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div class="flex-grow-1">
                            <h3 class="mb-1">{{greeting()}}</h3>
                        </div>
                        <div class="mt-3 mt-lg-0 add-session-btn">
                            <form action="javascript:void(0);">
                                <div class="row g-3 mb-0 align-items-center justify-content-lg-end">
                                    <div class="col-auto" *ngIf="isLoading()">
                                        <div class="spinner-border text-secondary align-self-center" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-auto">
                                        <button type="button" class="btn btn-primary w-100 w-lg-auto" (click)="addSession(sessionModal)" [disabled]="isLoading()">
                                            <i class="ri-add-circle-line align-middle me-1"></i> Add Session
                                        </button>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </form>
                        </div>
                    </div><!-- end card header -->
                </div><!--end col-->
            </div><!--end row-->

            <div class="row">
                <div class="col-xl-12">
                    <div class="card info-banner">
                        <div class="card-body p-0 pb-2">
                            <div class="w-100 info-header-line">
                                Introducing the
                            </div>
                            <h2>Drop Trainer Portal</h2>
                            <div class="info-subtitle">Schedule sessions with clients and manage your business using our new webapp.</div>
                            <div>&nbsp;</div>
                            <button type="button" class="btn btn-primary"  onclick="window.location.href='mailto:training@montvale.dropfitness.com';">
                                Need Help?
                            </button>
                        </div><!-- end card body -->
                    </div><!-- end card -->
                </div><!-- end col -->

            </div>

            <div class="row">
                <div *ngFor="let stat of statData" class="col-xl-6 col-md-12">
                    <app-stat [title]="stat.title" [value]="stat.value" [icon]="stat.icon" [percentage]="stat.percentage" [profit]="stat.profit" [description]="stat.description"></app-stat>
                </div>
            </div> <!-- end row-->

            <div class="card">
                <div class="card-body">
                    <!-- Nav tabs -->
                    <ul ngbNav #Border="ngbNav" [activeId]="1" class="nav nav-tabs-custom nav-success mb-3">
                      <li [ngbNavItem]="1">
                          <a ngbNavLink>
                            Upcoming Sessions
                          </a>
                          <ng-template ngbNavContent>
                            <div class="card">
                                <div class="card-body">
                                    <div class="table-responsive table-card">
                                        <app-list-sessions [ListSessions]="UpcomingSessions" (clickRow)="onClickUpcoming($event, sessionModal)"></app-list-sessions>
                                    </div>
                                </div>
                            </div>
                          </ng-template>
                      </li>
                      <li [ngbNavItem]="2">
                          <a ngbNavLink>
                            Past Sessions
                          </a>
                          <ng-template ngbNavContent>
                            <div class="card card-height-100">
                                <div class="card-body">
                                    <div class="table-responsive table-card">
                                        <app-list-sessions [ListSessions]="PastSessions" [scheduledText]="'Completed'" [scheduledClass]="'btn-soft-dark'" (clickRow)="onClickCompleted($event, sessionModal)"></app-list-sessions>
                                    </div>
                                </div> <!-- .card-body-->
                            </div> <!-- .card-->
                          </ng-template>
                      </li>
                    </ul>
                    <div class="tab-content text-muted">
                      <div [ngbNavOutlet]="Border"></div>
                    </div>
                </div><!-- end card-body -->
            </div>

            <app-add-session #sessionModal [trainerId]="trainer?.Id" [name]="user()?.FirstName" (bookingSuccess)="fetchData()" (cancelSession)="checkRefund(confirmRefund, $event)" (submit)="updateSession($event)"></app-add-session>
            <app-confirm-refund #confirmRefund (onConfirmRefund)="cancelSession($event)" [cancelBookingIds]="cancelBookingIds"></app-confirm-refund>

        </div> <!-- end .h-100-->

    </div> <!-- end col -->
</div>